/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Reason_Packaging_PnkInputs */

const vi_order_lot_trace_reason_packaging_pnk = /** @type {(inputs: Order_Lot_Trace_Reason_Packaging_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNK sản phẩm không có reason 'từ quy trình đóng gói'`)
};

/**

* @param {Order_Lot_Trace_Reason_Packaging_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_reason_packaging_pnk = /** @type {((inputs?: Order_Lot_Trace_Reason_Packaging_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Reason_Packaging_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_reason_packaging_pnk(inputs)
});